/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venueroomdescription2Inputs */

const en_venueroomdescription2 = /** @type {(inputs: Venueroomdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your place has its own Live Room. The first scan of the night opens it and it ends by itself the next morning. Put the code up at the door, the bar or on the tables.`)
};

const de_venueroomdescription2 = /** @type {(inputs: Venueroomdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Ort hat einen eigenen Live Room. Der erste Scan des Abends öffnet ihn, am nächsten Morgen endet er von selbst. Häng den Code beim Eingang, an der Bar oder auf den Tischen auf.`)
};

/**
* | output |
* | --- |
* | "Your place has its own Live Room. The first scan of the night opens it and it ends by itself the next morning. Put the code up at the door, the bar or on the..." |
*
* @param {Venueroomdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const venueroomdescription2 = /** @type {((inputs?: Venueroomdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venueroomdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_venueroomdescription2(inputs)
	return de_venueroomdescription2(inputs)
});
export { venueroomdescription2 as "venueRoomDescription" }